import Service, { service } from '@ember/service';
import config from 'walden-fast/config/environment';
import type UserService from './user';

export type EnvironmentFlag =
  | 'WALDEN_CHAT'
  | 'WALDEN_DASHBOARD'
  | 'WALDEN_VIEW_INBOUND_OUTBOUND'
  | 'WALDEN_VIEW_INVENTORY'
  | 'WALDEN_VIEW_ORDER_DETAILS'
  | 'WALDEN_VIEW_MASTER_DATA'
  | 'WALDEN_VIEW_TRANSPORT'
  | 'WALDEN_VIEW_ORDER_TRACKING'
  | 'WALDEN_VIEW_ORDER_2_CASH'
  | 'WALDEN_SERVICE_GREEN'
  | 'WALDEN_SERVICE_ML'
  | 'WALDEN_SERVICE_ORCHESTRATION'
  | 'WALDEN_SERVICE_TRACE'
  | 'WALDEN_SERVICE_BOX'
  | 'WALDEN_SERVICE_CONNECT'
  | 'WALDEN_SERVICE_PULSE'
  | 'WALDEN_SERVICE_VAS'
  | 'WALDEN_MANAGE_ORGANISATIONS'
  | 'WALDEN_MANAGE_SUBSCRIPTIONS'
  | 'WALDEN_NOTIFICATIONS'
  | 'WALDEN_TICKETS'
  | 'WALDEN_KPI'
  | 'WALDEN_SHOW_EXTERNAL_POWERBI_LINKS';

export type BackendFlag = 'NOT_YET_AVAILABLE';

export type FeatureFlag = EnvironmentFlag | BackendFlag;

export default class FeatureFlagsService extends Service {
  @service('user') declare user: UserService;

  async isEnabled(featureFlag: FeatureFlag) {
    if (config.features[featureFlag] !== undefined) {
      return Boolean(config.features[featureFlag]);
    }

    const user = await this.user.getUser();

    return user.enabledFeatures.includes(featureFlag as BackendFlag);
  }

  async anyEnabled(featureFlags: FeatureFlag[]) {
    const user = await this.user.getUser();
    return featureFlags.some(
      (featureFlag) =>
        Boolean(config.features[featureFlag]) ||
        user.enabledFeatures.includes(featureFlag as BackendFlag),
    );
  }
}

declare module '@ember/service' {
  interface Registry {
    'feature-flags': FeatureFlagsService;
  }
}
